import React, { useState } from "react";

function InlinePickInput({
  value,
  onChange,
  options,
  placeholder,
  autoFocus,
  maxVisibleItems = 2,
  onBlur,
  onKeyDown,
  onOptionSelect,
}) {
  const [open, setOpen] = useState(false);
  const currentValue = value != null ? String(value) : "";
  const list = Array.from(
    new Set(
      (Array.isArray(options) ? options : [])
        .map((opt) => (opt != null ? String(opt) : "").trim())
        .filter((v) => !!v)
    )
  ).slice(0, 50);

  return (
    <div style={{ position: "relative" }}>
      <input
        autoFocus={autoFocus}
        type="text"
        value={currentValue}
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        onBlur={(e) => {
          setTimeout(() => setOpen(false), 120);
          if (onBlur) onBlur(e);
        }}
        onKeyDown={(e) => {
          if (typeof onKeyDown === "function") onKeyDown(e);
        }}
        className="input input-full"
        placeholder={placeholder}
      />
      {open && list.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            width: "min(100%, 260px)",
            border: "1px solid #ced4da",
            borderRadius: 6,
            background: "#fff",
            zIndex: 20,
            maxHeight: `${Math.max(1, Number(maxVisibleItems) || 2) * 38}px`,
            overflowY: "auto",
            overflowX: "hidden",
            overscrollBehavior: "contain",
            boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
          }}
        >
          {list.map((opt) => (
            <button
              key={opt}
              type="button"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => {
                onChange(opt);
                setOpen(false);
                if (onOptionSelect) {
                  queueMicrotask(() => onOptionSelect(opt));
                }
              }}
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                textAlign: "left",
                height: 38,
                margin: 0,
                padding: "0 10px",
                border: "none",
                background: "transparent",
                color: "#212529",
                textDecoration: "none",
                font: "inherit",
                lineHeight: 1.2,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer",
              }}
            >
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default InlinePickInput;
